import IconBreadcrumbArrow from "@assets/icons/breadcrumb-arrow.svg?react";
import Icon from "@components/common/Icon";
import { NavLink, useLocation } from "react-router";

type BreadcrumbProps = {
	index: number;
	label?: string;
	url?: string;
	icon?: string;
};
function Breadcrumb({ index, label, url, icon }: BreadcrumbProps) {
	const key = `${icon ?? label ?? ""}_${index}`;
	const location = useLocation();
	const isActive = url ? location.pathname === url : false;
	const content = icon ? (
		<Icon name={icon} className="w-6 h-6" />
	) : url && !isActive ? (
		<NavLink
			to={url}
			className="min-w-0 truncate underline underline-offset-4"
		>
			{label}
		</NavLink>
	) : (
		<span className="min-w-0 truncate">{label}</span>
	);

	return (
		<span
			key={key}
			className={`flex items-center${icon ? "" : " min-w-0 shrink"}`}
		>
			{index > 0 && (
				<IconBreadcrumbArrow
					key={key + "_icon"}
					className="w-4 h-4 mx-2 text-grey"
				/>
			)}
			{content}
		</span>
	);
}

export default Breadcrumb;
